/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "create_bank_transaction_refund": {
            "nested": {
              "CreateBankTransactionRefundError": {
                "values": {
                  "DEFAULT_ENUM_DO_NOT_USE": 0,
                  "INVALID_REQUEST": 1,
                  "PAYMENT_NOT_FOUND": 2,
                  "INVALID_TRANSACTION_TYPE": 3,
                  "INVALID_STATE": 4,
                  "INVALID_REFUND_AMOUNT": 5,
                  "INSUFFICIENT_MERCHANT_BALANCE": 6
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.create_bank_transaction_refund?.nested?.CreateBankTransactionRefundError) {
  $root.addJSON(jsonData);
}

/**
 * Error types for a failed CreateBankTransactionRefundRequest.
 *
 * SOURCE CreateBankTransactionRefundError @ squareup/esperanto/common/create_bank_transaction_refund.proto at 7:1
 */
export const CreateBankTransactionRefundError = $root.lookupEnum('squareup.esperanto.create_bank_transaction_refund.CreateBankTransactionRefundError').values;